import React from 'react';
import { styled, Typography } from '@material-ui/core';
import { IconButton } from '../Buttons';

const getContainerColours = (variant, theme) => {
  switch (variant) {
    case 'warning':
      return {
        backgroundColor: theme.palette.common.halfColonialWhite,
        borderLeft: `4px solid ${theme.palette.common.yellow}`,
        color: theme.palette.common.yellow,
      };
    case 'error':
      return {
        backgroundColor: theme.palette.common.vanillaIce,
        borderLeft: `4px solid ${theme.palette.common.error}`,
        color: theme.palette.common.error,
      };
    default:
      return {
        backgroundColor: theme.palette.common.zanah,
        borderLeft: `4px solid ${theme.palette.common.success}`,
        color: theme.palette.common.success,
      };
  }
};

export const Container = styled('div')(({ theme, variant }) => ({
  ...getContainerColours(variant, theme),
  display: 'flex',
  padding: '14px 20px 14px 36px',
  borderRadius: '6px',
  alignItems: 'flex-start',
}));

export const AlertMessage = styled((props) => (
  <Typography variant="body2" {...props} />
))({
  fontWeight: 'bold',
});

export const DismissButton = styled(IconButton)({
  color: 'inherit',
  marginLeft: 'auto',
  marginTop: '4px',
  padding: '0 0 0 14px',
  '&:hover': {
    backgroundColor: 'transparent',
  },
});
